import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CampaignModel } from 'src/app/models/campaigns.model';
import { InventoryService } from 'src/app/services/inventory.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inventario-edit-recibido',
  templateUrl: './inventario-edit-recibido.component.html',
  styleUrls: ['./inventario-edit-recibido.component.scss']
})
export class InventarioEditRecibidoComponent {

  cantidadRecibida: number = 0;
  campana = [];
  tipo: string = '';
  id: number = 0;
  editRecibida = '';
  nombre: string = '';
  bitSemaforo: number = 0;
  id_mat: number = 0;
  id_camp: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    public dialogRef: MatDialogRef<InventarioEditRecibidoComponent>,
    private inventoryS: InventoryService,
  ) { }

  ngOnInit(): void {
    this.cantidadRecibida = this.data.recibido;
    this.campana = this.data.campaign;
    this.id = this.data.id;
    this.tipo = this.data.tipo;
    this.nombre = this.data.nombre;
    this.bitSemaforo = this.data.bitSemaforo;
    this.id_mat = this.data.id_mat;
    this.id_camp = this.data.id_camp;
  }

  guardarCantidadRecibida(){

    let dataSend = {
      campana: this.campana,
      cantidad: this.editRecibida,
      tipo: this.tipo,
      id: this.id,
      bitSemaforo: this.bitSemaforo,
      id_mat: this.id_mat,
      id_camp: this.id_camp
    }

    this.inventoryS.updateCantidadRecibida(dataSend).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Guardado'
          }).then(() => {
            this.dialogRef.close({ reload: true });            
          });
        }
      },
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: 'Ocurrió un error al guardar el registro, por favor vuelva a intentarlo.'
        });
      }
    );
      
  }

}
